import { z } from 'zod';
import { AUTOMATIC_SUPPORTED_UNITS_SCHEMA } from '@schuettflix/interfaces';
import { EXCLUDED_PARTNER_ORGANIZATION_IDS } from '@/shared/constants/excludedPartnerOrganizations.ts';
import { PriceSchema, PriceSchemaRules } from '@/shared/schemas/PriceSchema.ts';
import { LocationConfigurationSchema } from '@/modules/location/domain/LocationConfigurationSchema.ts';
import { LocationTypeSchema } from '@/modules/location/domain/LocationSchema.ts';
import { CarrierOrganizationIdSchema } from '@/shared/schemas/CarrierOrganizationIdSchema.ts';

export type IsPurchaseTransportIncludedUnionParams = {
    errorMessages?: { required?: string };
    formRules?: { priceRules?: PriceSchemaRules };
};

export function getIsPurchaseTransportIncludedUnion(params?: IsPurchaseTransportIncludedUnionParams) {
    const { errorMessages = {}, formRules = {} } = params ?? {};
    const { required } = errorMessages;
    const { priceRules } = formRules;

    return z.discriminatedUnion('isPurchaseTransportIncluded', [
        z.object({
            isPurchaseTransportIncluded: z.literal(false),
            carrierOrganizationId: CarrierOrganizationIdSchema({
                excludedIds: [...EXCLUDED_PARTNER_ORGANIZATION_IDS],
                errorMessages: { required },
            }),
            purchaseTransportQuantity: z.number({ required_error: required }).nonnegative(required),
            purchaseTransportUnit: z.enum(AUTOMATIC_SUPPORTED_UNITS_SCHEMA.options, { required_error: required }),
            purchaseTransportPrice: PriceSchema({
                ...priceRules,
                errorMessages: { required, nonNegative: required, multipleOf: required },
            }),
            purchaseTransportTaxClassId: z.string({ message: required }),
            showZeroPurchaseTransportPrice: z.boolean(),
            loadingLocation: z.object(LocationConfigurationSchema.shape, { message: required }),
            unloadingLocation: z.object(LocationConfigurationSchema.shape, { message: required }),
            weighingLocation: z.enum(LocationTypeSchema.options, { message: required }).nullable(),
        }),
        z.object({
            isPurchaseTransportIncluded: z.literal(true),
        }),
    ]);
}
